<template>
  <el-select
    v-if="!readonly"
    v-model="selected"
    :multiple="params.multiple"
    :value-key="params.key"
    filterable
    clearable
    style="width: 100%"
  >
    <el-option
      v-for="(option, optionName, index) in data"
      :key="index"
      :label="option[params.label]"
      :value="option"
      :readonly="true"
    />
  </el-select>
  <el-input
    v-else
    v-model="value"
    :readonly="readonly"
    :class="{ readonly: readonly }"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default() {
        const { multiple } = this.params;
        if (multiple) {
          return [];
        }
        return null;
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Внутри компонента используем объект с названием и id
     * наружу отдаем массив с id
     */
    selected: {
      get() {
        if (Array.isArray(this.value) && Number(this.value[0])) {
          return this.value.map((e) =>
            this.data.find((item) => item[this.params.key] === e)
          );
        }
        if (typeof this.value !== "object") {
          return this.data.find((item) => item[this.params.key] === this.value);
        }
        return this.value;
      },
      set(val) {
        this.$emit(
          "input",
          Array.isArray(val)
            ? val.map((e) => e[this.params.key])
            : val[this.params.key] === undefined
            ? null
            : val[this.params.key]
        );
      },
    },
  },
};
</script>
